import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {environment} from '@env/environment';
import {AppModule} from './app/app.module';

(async () => {
    if (environment.production) {
        enableProdMode();
        if (window) {
            window.console.log = function () {
            };
        }
    } else {
        try {
            const newEnvironment = await getEnvironmentModule();
            Object.assign(environment, newEnvironment);
        } catch (err) {
            console.error('Error loading environment configuration:', err);
        }
    }
})();

function getEnvironmentModule() {
    return new Promise((resolve, reject): void => {
        const urlParams = new URLSearchParams(window.location.search);
        const env = urlParams.get('env');
        let envModule;
        switch (env) {
            case 'uat':
                envModule = import('@env/environment.uat');
                break;
            case 'qa':
                envModule = import('@env/environment.qa');
                break;
            case 'staging':
                envModule = import('@env/environment.staging');
                break;
            default:
                envModule = import('@env/environment');
        }
        if (envModule) {
            envModule.then(envM => {
                resolve(envM.environment);
            }).catch(reject);
        }
    });
}


platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.log(err));
